import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import dayjs from 'dayjs';
import { contentTypeId } from '../../contentful/dist/uswitch-ev-utils-contentful.esm.js';
import '../../dist/objectSpread2-811c5212.esm.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../obj/dist/uswitch-ev-utils-obj.esm.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import '../../nil/dist/uswitch-ev-utils-nil.esm.js';

var getPageDates = function getPageDates(includes) {
  var _Object$values$reduce = Object.values(includes).reduce(function (_ref, it) {
      var _it$sys, _it$sys2, _it$sys3, _it$sys4;
      var _ref2 = _slicedToArray(_ref, 2),
        updated = _ref2[0],
        created = _ref2[1];
      return [updated > dayjs(it === null || it === void 0 ? void 0 : (_it$sys = it.sys) === null || _it$sys === void 0 ? void 0 : _it$sys.updatedAt) ? updated : it === null || it === void 0 ? void 0 : (_it$sys2 = it.sys) === null || _it$sys2 === void 0 ? void 0 : _it$sys2.updatedAt, created > dayjs(it === null || it === void 0 ? void 0 : (_it$sys3 = it.sys) === null || _it$sys3 === void 0 ? void 0 : _it$sys3.createdAt) ? created : it === null || it === void 0 ? void 0 : (_it$sys4 = it.sys) === null || _it$sys4 === void 0 ? void 0 : _it$sys4.createdAt];
    }, [0, 0]),
    _Object$values$reduce2 = _slicedToArray(_Object$values$reduce, 2),
    updated = _Object$values$reduce2[0],
    created = _Object$values$reduce2[1];
  return {
    updated: updated,
    created: created
  };
};
var getUrlDates = function getUrlDates(_ref3) {
  var _items$, _items$$fields;
  var _ref3$includes = _ref3.includes,
    includes = _ref3$includes === void 0 ? {} : _ref3$includes,
    items = _ref3.items;
  var publishDate;
  var updatedDate;
  if (items !== null && items !== void 0 && (_items$ = items[0]) !== null && _items$ !== void 0 && (_items$$fields = _items$.fields) !== null && _items$$fields !== void 0 && _items$$fields.url) {
    publishDate = items[0].fields.publishDate;
    updatedDate = items[0].fields.updatedDate;
  } else {
    var _Object$values$find;
    var dateFields = (_Object$values$find = Object.values(includes || {}).find(function (mod) {
      return contentTypeId(mod) === 'url';
    })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.fields;
    if (dateFields) {
      publishDate = dateFields.publishDate;
      updatedDate = dateFields.updatedDate;
    }
  }
  if (!publishDate) {
    publishDate = getPageDates(includes).created;
  }
  return {
    publishDate: publishDate,
    updatedDate: updatedDate
  };
};
var sortByDate = function sortByDate(a, b) {
  var _a$fields, _a$fields2, _b$fields, _b$fields2;
  var aDate = new Date((a === null || a === void 0 ? void 0 : (_a$fields = a.fields) === null || _a$fields === void 0 ? void 0 : _a$fields.updatedDate) || (a === null || a === void 0 ? void 0 : (_a$fields2 = a.fields) === null || _a$fields2 === void 0 ? void 0 : _a$fields2.publishDate));
  var bDate = new Date((b === null || b === void 0 ? void 0 : (_b$fields = b.fields) === null || _b$fields === void 0 ? void 0 : _b$fields.updatedDate) || (b === null || b === void 0 ? void 0 : (_b$fields2 = b.fields) === null || _b$fields2 === void 0 ? void 0 : _b$fields2.publishDate));
  return bDate - aDate;
};

export { getUrlDates, sortByDate };
